import { render, staticRenderFns } from "./access-google-ads.vue?vue&type=template&id=f1fb2476&scoped=true"
import script from "./access-google-ads.vue?vue&type=script&lang=js"
export * from "./access-google-ads.vue?vue&type=script&lang=js"
import style0 from "./access-google-ads.vue?vue&type=style&index=0&id=f1fb2476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fb2476",
  null
  
)

export default component.exports